import React from 'react';
import { Flex } from 'workspace-core-ui';

// TODO: for future cases where we need to mess with images some more
const Img = ({ ...delegated }) => <Flex as="img" {...delegated} />;

export default Img;
